import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { APP_URLS, TenantId } from 'src/app/Models/url';
import { CourseService } from 'src/app/services/course.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-coursescontent',
  templateUrl: './coursescontent.component.html',
  styleUrls: ['./coursescontent.component.css'],
})
export class CoursescontentComponent implements OnInit {
  CoursesData = [];
  student_Id = '';
  showDialogReg = false;
  CartList = [];
  FavList = [];
  ID: string;

  showType: string = 'all';
  isnoDataFound: boolean = false;
  noDataMsg: string;

  Chapters = [];
  FinalChaptersArray = [];

  constructor(
    public service: CourseService,
    private toastr: UserService,
    private router: Router,
    private userservice: UserService
  ) {}

  ngOnInit(): void {
    this.getData();
    var profileData = localStorage.getItem('profilesummaryData');
    if (profileData != undefined && typeof profileData == 'string') {
      this.student_Id = JSON.parse(localStorage.getItem('userDetails'))._id;
    }
  }

  getData() {
    let dataofcart = localStorage.getItem('cartdata');
    if (dataofcart != null) {
      this.CartList = dataofcart.split(',');
    }
    this.getCourseList();
  }

  getCourseList() {
    let url = APP_URLS.latestcourse;
    this.service.getCallwithHeader(url).subscribe((res: any) => {
      if (res.all.length > 0) {
        this.CoursesData = [];
        var targetArr = res[this.showType];
        for (let i = targetArr.length - 1; i >= 0; i--) {
          this.CoursesData.push(targetArr[i]);
        }

        this.CoursesData.sort((a, b) => {
          return <any>new Date(b.created) - <any>new Date(a.created);
        });

        if (!this.CoursesData.length) {
          this.isnoDataFound = true;
          if (this.showType == 'all') {
            this.noDataMsg = 'No course(s) found';
          } else if (this.showType == 'applied') {
            this.noDataMsg = 'No course(s) are applied';
          } else if (this.showType == 'assigned') {
            this.noDataMsg = 'No course(s) are approved';
          } else if (this.showType == 'favorites') {
            this.noDataMsg = 'No favourite course(s) found';
          }
        }

        if (!this.student_Id) {
          this.CoursesData.forEach((x) => {
            if (this.CartList.includes(x._id)) {
              x['text_btn'] = 'Waiting for payment';
            }
          });
        }
      }
    });
  }

  addFavorateFun(data) {
    if (this.student_Id) {
      let url = APP_URLS.applyAndFavourate + data + '?favorite=true';

      this.service.putCall(url, {}).subscribe(
        (data: any) => {
          this.userservice.showSuccess(data.respMessage);
          this.service.selectedcourse('', '');
          this.getData();
        },
        (err) => {}
      );
    } else {
      this.toastr.showError('Please register or login to continue');
    }
  }

  AddApply(data) {
    let url = APP_URLS.applyAndFavourate + data._id + '?applycourse=true';

    if (this.student_Id) {
      this.service.putCall(url, {}).subscribe(
        (data: any) => {
          this.toastr.showSuccess(data.respMessage);
          this.getCourseList();
        },
        (err) => {}
      );
    } else {
      this.toastr.showError('Please register or login to continue');
      this.service.selectedcourse(data._id, 'apply');
      this.showDialogReg = true;
    }
  }

  addToCart(course) {
    let url = APP_URLS.addtocart + course._id + '?addtocart=true';

    if (localStorage.getItem('token') && this.student_Id) {
      this.service.putCall(url, {}).subscribe(
        (data: any) => {
          if (data.suc_arr.length > 0) {
            this.userservice.showSuccess(data.suc_arr[0]);
            this.userservice.setCart('data');
          }
          if (data.err_arr.length > 0) {
            this.userservice.showError(data.err_arr[0]);
          }
          this.getCourseList();
        },
        (err) => {}
      );
    } else {
      // this.toastr.showError('Please register or login to continue');
      // this.service.selectedcourse(course._id, "addtocart")
      // this.showDialogReg=true;
      this.addtoLocalStorage(course);
    }
  }

  addtoLocalStorage(course) {
    this.CartList.push(course._id);
    localStorage.setItem('cartdata', this.CartList.toString());
    this.userservice.setCart('data');
    this.userservice.showSuccess('Course Successfully added to Your Cart');
    this.getData();
  }

  goToCart() {
    this.router.navigate(['app/Cart']);
  }

  addtofavLocalStorage(course) {
    this.FavList.push(course._id);
    localStorage.setItem('favdata', this.FavList.toString());
    this.userservice.showSuccess('Course Successfully added to Favourite List');
    this.getData();
  }

  removeFav(course) {
    if (this.student_Id) {
      let favarry = [];
      let url = APP_URLS.favmulti;
      favarry.push(course._id);
      let payload = {
        courseids: favarry,
        target: 'remove',
      };
      this.service.putCall(url, payload).subscribe(
        (data: any) => {
          if (data.suc_arr.length > 0) {
            this.userservice.showSuccess(data.suc_arr[0]);
          }
          if (data.err_arr.length > 0) {
            this.userservice.showError(data.err_arr[0]);
          }
          this.getData();
        },
        (err) => {}
      );
    } else {
      this.FavList.forEach((x, i) => {
        if (x == course._id) {
          this.FavList.splice(i, 1);
          let data = this.FavList;
          if (data.length > 0) {
            localStorage.setItem('favdata', data.toString());
          }
          if (data.length == 0) {
            localStorage.removeItem('favdata');
          }

          this.userservice.showSuccess('Removed from Favourite List');
          this.getData();
        }
      });
    }
  }

  waitingForApproval() {
    this.service.showError(
      'Waiting for Admin approval. Contact your Admin for further information'
    );
  }

  openCourse(Training) {
    localStorage.setItem('courseId', Training._id);
    localStorage.setItem('TrainingName', Training.name);
    localStorage.setItem('uuid', Training.resume_chapter);
    if (Training.apply_status == 'assigned' && Training.resume_chapter == '') {
      this.router.navigate(['app/Mycourses/', Training._id]);
    }
    if (Training.apply_status == 'assigned' && Training.resume_chapter != '') {
      this.ID = localStorage.getItem('courseId');
      let url =
        APP_URLS.newchapters +
        '{"criteria":[{"key":"tenantId","value":"' +
        TenantId +
        '","type":"eq"},{"key":"course","value":"' +
        this.ID +
        '","type":"eq"}]}';
      this.service.getCallwithHeader(url).subscribe(
        (res: any) => {
          this.Chapters = res.cou_overview;
          this.setChaptersData();
        },
        (err) => {}
      );
    }
  }

  async setChaptersData() {
    await this.Chapters.forEach((x, i) => {
      x['accordion'] = '#accordion' + i;
      x['accordionID'] = 'accordion' + i;
      x.child.forEach((y, index) => {
        y['childaccordion'] = '#childaccordion' + index;
        y['childaccordionID'] = 'childaccordion' + index;
        if (y.chapter_type == 'lesson') {
          y['icon'] = 'fa fa-book';
        }
        if (y.chapter_type == 'assignment') {
          y['icon'] = 'fa fa-code';
        }
        if (y.chapter_type == 'downloads') {
          y['icon'] = 'fa fa-cloud-download-alt';
        }
        if (y.chapter_type == 'test' || y.chapter_type == 'qatest') {
          y['icon'] = 'fa fa-pencil-alt';
        }
        if (y.chapter_type == 'quiz') {
          y['icon'] = 'fa fa-graduation-cap';
        }
        if (y.chapter_type == 'chapter') {
          y['icon'] = 'fa fa-bars';
        }
      });
      this.FinalChaptersArray.push(x);
      localStorage.setItem(
        'AllChapters',
        JSON.stringify(this.FinalChaptersArray)
      );
      var Trainingid = localStorage.getItem('courseId');
      var TrainingName = localStorage.getItem('TrainingName');
      var resume_chapter = localStorage.getItem('uuid');
      this.router.navigate([
        'app/Mychapter/',
        Trainingid + '-' + resume_chapter,
        TrainingName.replace(/\s/g, '-'),
      ]);
    });
  }

  selectCourse(data) {
    this.service.selectCourseById(data);
    this.service.senddataToHeader(data);
    this.router.navigate(['app/' + data.slug]);
  }
}
